export default "__VITE_ASSET__BEQbzAaG__"